<template>
  <div class="price-detail">
    <div class="breadcrumb" style="background: #fff">申请特殊价格</div>
    <div class="third-title"><span> SKU组价格信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="平台号:">
          <span>{{basicInfo.platformNum}}</span>
        </el-form-item>
        <el-form-item label="平台名称:">
          <span>{{basicInfo.platformName}}</span>
        </el-form-item>
        <el-form-item label="申请价格:">
          <el-table :data="basicInfo.priceData" border width="100%">
            <el-table-column min-width="100px" prop="skuName" label="SKU名称">
            </el-table-column>
            <el-table-column min-width="80px" label="基础P数">
              <template v-slot="scope">
                <span>{{ scope.row.page }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="maxpage" min-width="80px" label="最大P数">
            </el-table-column>
            <el-table-column prop="apage" min-width="120px" label="一次增加P数">
            </el-table-column>
            <el-table-column prop="price" min-width="100px" label="基础P平台价格">
            </el-table-column>
            <el-table-column prop="applyPrice" min-width="100px" label="申请基础P平台价格">
            </el-table-column>
            <el-table-column prop="aprice" min-width="100px" label="增加一次平台价格">
            </el-table-column>
            <el-table-column prop="applyAPrice" min-width="100px" label="申请增加一次平台价格">
            </el-table-column>
            <el-table-column min-width="100px" label="申请基础P数价格" prop="applyPrice">
            </el-table-column>
            <el-table-column min-width="100px" label="申请折扣" prop="applyDiscount">
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="详细价格表:">
          <el-button round @click="count">计算</el-button>
        </el-form-item>
        <el-form-item label="" v-if="isShow" class="price-details">
          <div style="width: 452px;margin-bottom: 20px;" v-for="(item, index) in basicInfo.tableList" :key="index">
            <el-table :data="item" border style="width: 452px">
              <el-table-column prop="page" label="P数" width="150"></el-table-column>
              <el-table-column prop="price" label="平台价格" width="150"></el-table-column>
              <el-table-column prop="applyprice" label="申请平台价格" width="150"></el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round>审核拒绝</el-button>
      <el-button round type="primary">审核通过</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
export default {
  name: 'price-detail',
  components: {
    CombinedDialog
  },
  data () {
    return {
      isShow: false,
      basicInfo: {
        platformNum: '1111111',
        platformName: '松动剂',
        applyWay: '1',
        priceData: [{
          skuName: 'ertrt',
          page: 10,
          maxpage: 20,
          apage: 2,
          price: 10,
          applyPrice: 15,
          aprice: 5,
          applyAPrice: 15,
          applyDiscount: 0.7
        }],
        tableList: []
      }
    }
  },
  methods: {
    count () {
      this.isShow = true
      this.basicInfo.priceData.forEach((item, index) => {
        this.basicInfo.tableList[index] = []
        let page = parseInt(item.page)
        let apage = parseInt(item.apage)
        let maxpage = parseInt(item.maxpage)
        for (let i = page; i <= maxpage; i += apage) {
          let price = parseInt(item.aprice) * Math.ceil(i - page) / apage
          let price2 = parseInt(item.applyAPrice) * Math.ceil(i - page) / apage
          this.basicInfo.tableList[index].push({
            page: i,
            price: (parseInt(item.price) + price).toFixed(2),
            applyprice: ((parseInt(item.applyPrice) + price2) * item.applyDiscount).toFixed(2)
          })
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
